import React from 'react';

import { SidebarModalSectionComponent } from 'design/sidebarModal';
import {
  SidebarModalNavigationControlComponent,
  SidebarModalNavigationLayoutComponent,
} from 'design/sidebarModalNavigation';
import { useIntlDictionary } from 'hooks/useIntlDictionary';
import { TextComponent } from 'design/text/textComponents';
import { ModalPressControlComponent } from 'design/modalPressControl';
import { useHistory } from 'react-router';
import { routes } from 'utils/routes';
import { PartnerAccountManagerScreen } from './PartnerAccountManager';

type Props = {
  currentScreen: PartnerAccountManagerScreen;
  onViewSummary(): void;
  onViewFinances(): void;
};

export const PartnerAccountManagerHeader = (props: Props) => {
  const {
    currentScreen,
    onViewSummary: viewSummary,
    onViewFinances: viewFinances,
  } = props;

  const {
    partnerAccountManager: { header: ownDictionary },
  } = useIntlDictionary();

  const history = useHistory();

  const signOut = React.useCallback(() => {
    history.push(routes.signOut());
  }, [history]);

  return (
    <SidebarModalSectionComponent
      theme="head"
      content={
        <TextComponent size="mpp" weight="medium">
          {ownDictionary.titleText}
        </TextComponent>
      }
      actions={
        <>
          <ModalPressControlComponent
            type="button"
            theme="secondary"
            onPress={signOut}
          >
            {ownDictionary.signOutActionText}
          </ModalPressControlComponent>
        </>
      }
      navigation={
        <SidebarModalNavigationLayoutComponent>
          <SidebarModalNavigationControlComponent
            onPress={viewSummary}
            active={currentScreen === 'SUMMARY'}
          >
            <TextComponent>{ownDictionary.accountTabText}</TextComponent>
          </SidebarModalNavigationControlComponent>
          <SidebarModalNavigationControlComponent
            onPress={viewFinances}
            active={currentScreen === 'FINANCES'}
          >
            <TextComponent>{ownDictionary.financesTabText}</TextComponent>
          </SidebarModalNavigationControlComponent>
        </SidebarModalNavigationLayoutComponent>
      }
    />
  );
};
